import { Injectable } from '@angular/core'
import { NavItem } from './nav-item.interface'

@Injectable()
export abstract class SidebarNavService {
    /**
     * Returns a sidebar-nav items config NavData
     */
    abstract getSidebarNavItemsConfig(): NavItem[]
}

@Injectable()
export class SidebarNavHelper {
    itemType(item: NavItem): string {
        if (item.divider) {
            return 'divider'
        } else if (item.title) {
            return 'title'
        } else if (item.children && item.children.length > 0) {
            return 'group'
            // } else if (item.label) {
            //   return 'label';
        } else if (!Object.keys(item).length) {
            return 'empty'
        } else {
            return 'link'
        }
    }

    public isActive(router: any, item: NavItem): boolean {
        return router.isActive(item.url, false)
    }

    public hasBadge = (item: NavItem) => Boolean(item.badge)
    public hasIcon = (item: NavItem) => Boolean(item.icon) || item.icon === ''
    // public hasIconComponent = (item: NavItem) => Boolean(item.iconComponent)

    public getIconClass(item: NavItem): any {
        const classes = {
            'nav-icon': true,
        }
        const icon = item.icon
        // @ts-ignore
        classes[icon] = this.hasIcon(item)
        return classes
    }
}
